import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import PrettyImage from "./pretty-image"
import { ThemeContext } from "./theme"

export default function MarkdownImage({ src, width, height }) {
  const { colorMode, setColorMode } = React.useContext(ThemeContext)
  const { allImageSharp } = useStaticQuery(graphql`
    query {
      allImageSharp {
        edges {
          node {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
              originalName
            }
          }
        }
      }
    }
  `)
  const image = allImageSharp.edges.find(
    edge => edge.node.fluid.originalName === src
  )
  if (!image || !colorMode) {
    return null
  }
  return (
    <div style={{ width: width, height: height}}>
      <PrettyImage style={{filter: colorMode === "light" ? "invert(3%)" : "invert(100%)"}} fluid={image.node.fluid} />
    </div>
  )
}
